// "Your song plays in 4:32 / is playing now": a small banner for the signed-in contributor, from 10
// minutes before one of their songs plays until it ends, on whichever stream it plays. Dismissable
// per play.
import { useState } from "react";
import { Link } from "../lib/router";
import { useMyPlays, type MyPlay } from "../myPlays";
import { useTicker } from "../river/context";
import { STREAM_BPM, streamHref } from "../stream";

const LEAD_MS = 10 * 60_000;
const key = (p: MyPlay) => `${p.bpm}:${p.day}:${p.slot}`;

function countdown(ms: number): string {
  const s = Math.max(0, Math.ceil(ms / 1000));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
}

export function MyPlayNotice() {
  const plays = useMyPlays((s) => s.plays);
  const offsetMs = useMyPlays((s) => s.offsetMs);
  const [dismissed, setDismissed] = useState<ReadonlySet<string>>(new Set());
  useTicker(1000);
  const now = Date.now() + offsetMs;
  const play = plays.find((p) => p.endMs > now && p.startMs - LEAD_MS <= now && !dismissed.has(key(p)));
  if (!play) return null;
  const playing = play.startMs <= now;
  const name = play.title ? `“${play.title}”` : "Your song";
  const where = play.bpm === 72 ? "The Infinite 72" : "The Infinite";
  const here = play.bpm === STREAM_BPM;
  return (
    <div className={`my-play-notice${playing ? " playing" : ""}`} role="status" data-testid="my-play-notice">
      <span className="my-play-dot" aria-hidden="true" />
      <span>
        {playing ? (
          <>
            {name} is playing now{play.repeat ? ` (encore ${play.repeat + 1})` : ""} on {where}.
          </>
        ) : (
          <>
            {name} plays in <strong className="mono">{countdown(play.startMs - now)}</strong> on {where}.
          </>
        )}
      </span>
      {here ? (
        <Link className="btn btn-small btn-primary" href="/">
          Listen
        </Link>
      ) : (
        <a className="btn btn-small btn-primary" href={streamHref(play.bpm === 72 ? 72 : 125, "/")}>
          Listen
        </a>
      )}
      <button
        type="button"
        className="btn btn-small btn-ghost"
        aria-label="Hide this notice"
        onClick={() => setDismissed((d) => new Set([...d, key(play)]))}
      >
        ✕
      </button>
    </div>
  );
}
